import { useLocalStorage } from '@/composition/localStorage'

export const useLocalStorageValue = <T>(key: string) => {
  const localStorage = useLocalStorage()

  const get = () => {
    return localStorage.get<T>(key)
  }

  const set = (value: T) => {
    localStorage.set(key, JSON.stringify(value))
  }

  const remove = () => {
    localStorage.remove(key)
  }

  return {
    get,
    set,
    remove,
  }
}
